:host {
  display: inline-flex;
}
#control {
  display: inline-flex;
  align-self: stretch;
  white-space: nowrap;
  flex: inherit;
  width: 100%;
}
#control aha-button {
  display: inline-flex;
  align-items: center;
}
/* Ensure that the control button is visible when the menu is open. */
:host([open]) #control {
  visibility: visible;
}
slot[name='control'] ::slotted(*) {
  display: inherit;
  align-items: center;
}

/* DEPRECATED: old extension handling. */
:host {
  --aha-menu--z-index: 10000;
}

#popup {
  position: fixed;
  background: var(--theme-primary-background);
  border-radius: 4px;
  width: max-content;
  min-width: 15ch;
  overflow: hidden;
  box-shadow: 0 5px 10px 0 rgba(0 0 0 / 20%);
  border: 1px solid var(--theme-primary-border);
  padding: var(--spacer-2);
  z-index: var(--aha-menu--z-index);
  outline: 0;
}

#popup ::slotted(hr) {
  border: none;
  height: 1px;
  background: var(--aha-gray-400);
}

#popup slot:not([name]) {
  display: unset;
}
